const whitelabel = {
  state: {
    whitelabel: {
      enabled: false,
      theme: 'pagarme',
      domain: 'pagar.me'
    }
  },
  getters: {
    whitelabel (state) {
      return state.whitelabel
    },
    labelTheme (state) {
      const theme = state.whitelabel.theme
      const name = {
        mundipagg: 'Mundipagg',
        pagarme: 'Pagar.me'
      }
      return name[theme]
    }
  },
  mutations: {
    updateWhitelabel (state, value) {
      state.whitelabel = value
    }
  },
  actions: {
    updateWhitelabel ({ commit }, value) {
      commit('updateWhitelabel', value)
    },
    loadEmeraldByTheme ({ commit }, theme) {
      const emerald = () => import('emerald-workbench/dist/emerald.pagarme.min.css')
      commit('updateWhitelabel', { enabled: true, theme: theme })
      emerald()
    }
  }
}
export default whitelabel
